import React, { useState, useEffect, useMemo } from 'react'
import Dropdown from 'src/component/custom/Dropdown';
import { useObjCommonFilterStore } from 'src/hooks/objCommonFilter';
import ObjCommonFilterSelection from 'src/component/custom/ObjCommonFilterSelection';
import Helper from 'src/helper/Helper';
import System from 'src/helper/system';

const OrderHistorySearchFilter = () => {
    const { translation: t } = System;
    const initialValues = {
        searchType: '',
        searchKeyword: '',
        searchArrayData: ''
    }
    const [{ filter_list }, { }, { set_filter_list }] = useObjCommonFilterStore();
    const [searchData, setSearchData] = useState({});
    const [searchValues, setSearchValues] = useState(initialValues);
    const [validationError, setValidationError] = useState({ searchError: '', searchByError: '' })

    const searchByDropdown = [
        { key: 'orderNumber', slug: t('orderNumber') },
        { key: 'poNumber', slug: t('pONumber') },
        { key: 'invoiceNo', slug: t('invoiceNumber') },
        { key: 'trackingNo', slug: t('trackingWayBill') },
        { key: 'doNumber', slug: t('doNumber') },
        { key: 'orderType', slug: t('orderType') },
    ]
    const searchOptionModified = useMemo(() => {
        const modifiedOption = {};
        searchByDropdown.forEach(v => {
            modifiedOption[v.key] = v.slug;
        });
        return modifiedOption;
    })

    const orderTypeList = [
        { key: t('online'), slug: t('online'), searchKey: "Online" },
        { key: t('offline'), slug: t('offline'), searchKey: "Offline" }
    ]

    const setSearch = async (data) => {
        if (data) {
            setValidationError(prevState => ({ ...prevState, searchByError: '', searchError: '' }));
            setSearchValues(prevState => ({ ...prevState, searchArrayData: '', searchKeyword: '', searchType: data }));
        }
    };

    const setSearchKey = (data) => {
        setSearchValues(prevState => ({ ...prevState, searchKeyword: data }));
    };

    const onSearch = async () => {
        let search = {};
        const requiredLength = searchValues?.searchType === 'orderNumber' ? 4 : 2;

        if (searchValues.searchKeyword?.length < requiredLength) {
            const errorKey = searchValues?.searchType === 'orderNumber'
                ? 'pleaseEnter4CharactersToSearch'
                : 'pleaseEnter2CharactersToSearch';

            setValidationError(prevState => ({ ...prevState, searchError: t(errorKey) }));
        } else
            if (!searchValues.searchType) {
                setValidationError(prevState => ({ ...prevState, searchByError: t('pleaseSelectSearchByOption') + "." }));
            } else {
                setValidationError(prevState => ({ ...prevState, searchError: "", searchByError: '' }));

                search = {
                    [searchValues.searchType]: searchValues.searchKeyword
                };

                setSearchData(search);

                const keyToSearchType = {
                    orderNumber: t('orderNumber'),
                    poNumber: t('pONumber'),
                    invoiceNo: t('invoiceNumber'),
                    trackingNo: t('trackingWayBill'),
                    doNumber: t('doNumber'),
                    orderType: t('orderType'),
                };

                const filterList = Object.entries(search)
                    .filter(([key, value]) => Helper.valueIsNotNull(value))
                    .map(([key, value]) => ({
                        searchType: keyToSearchType[key],
                        key,
                        [Array.isArray(value) ? 'searchKeywordArr' : 'searchKeyword']: value,
                        searchValue: orderTypeList.find(item => item.key === value)?.searchKey
                    }));

                const filterListObject = filterList.reduce((acc, curr) => {
                    acc[curr.key] = curr;
                    return acc;
                }, {});

                const data = await updateFilterList(filter_list, filterListObject, keyToSearchType)
                set_filter_list(data);
            }
    };

    const updateFilterList = (prevFilterList, filterListObject, keyToSearchType) => {
        const existingFilters = prevFilterList || {};

        const updatedFilterList = Object.entries(existingFilters)
            .filter(([key]) => !keyToSearchType.hasOwnProperty(key))
            .reduce((acc, [key, value]) => {
                acc[key] = value;
                return acc;
            }, {});

        return { ...updatedFilterList, ...filterListObject };
    };

    useEffect(() => {
        if (!filter_list || Object.keys(filter_list).length === 0) {
            setSearchValues(prevState => ({ ...prevState, searchArrayData: '', searchKeyword: '', searchType: '' }));
            setValidationError(prevState => ({ ...prevState, searchError: "", searchByError: '' }));
            setSearchData({})
        } else {
            const filterKeys = Object.keys(filter_list);

            const updatedSearchData = Object.keys(searchData).reduce((acc, key) => {
                if (filterKeys.includes(key)) {
                    acc[key] = searchData[key];
                }
                return acc;
            }, {});

            setSearchData(updatedSearchData);
        }
        setSearchValues(prevState => ({ ...prevState, searchArrayData: filter_list?.Manufacturer?.searchKeywordArr }));
    }, [filter_list]);

    return (
        <>
            <div className="d-flex flex-wrap orderhistory-filter">
                <div className='m-b-10 m-r-15 '>
                    <label className="my-0 me-2" htmlFor="searchBy">{t('searchBy')}</label>
                    <Dropdown defaultText={"-- " + t('select') + " --"}
                        className={`test ${validationError.searchByError && 'error'}`}
                        id="ddlSearchBy"
                        onDdlCallback={setSearch}
                        ddlList={searchByDropdown}
                        label={"slug"}
                        value={"key"}
                        selectedValue={searchValues.searchType}
                    />
                    {validationError.searchByError.trim().length > 0 && <p className='error mb-0'>{validationError.searchByError}</p>}
                </div>
                {searchValues.searchType.toLocaleLowerCase() !== 'ordertype' &&
                    <div className="m-b-10 m-r-15 maxw240 minw240">
                        <label className="my-0 me-2"></label>
                        <input type="text" className={`form-control form-control-sm ${validationError.searchError && 'error'}`} placeholder={searchOptionModified[searchValues.searchType] || t('searchBy')} name={searchValues.searchType} value={searchValues.searchKeyword}
                            onChange={({ target: { value } }) => { setValidationError(prevState => ({ ...prevState, searchError: "" })); setSearchKey(value) }}
                        />
                        {validationError.searchError.trim().length > 0 && <p className='error mb-0'>{validationError.searchError}</p>}
                    </div>
                }

                {searchValues.searchType !== '' && searchValues.searchType.toLocaleLowerCase() === 'ordertype' &&
                    <div className="m-b-5 m-r-15 maxw240 minw240">
                        <label className="my-0 me-2"></label>
                        <Dropdown defaultText={t('selectOrderType')}
                            class={'test'}
                            id="ddlOrderType"
                            onDdlCallback={setSearchKey}
                            ddlList={orderTypeList}
                            label={"slug"}
                            value={"key"}
                            selectedValue={searchValues.searchKeyword}
                        />
                    </div>
                }

                <div className='m-b-10 me-3 mt-3 pt-1'>
                    <button className={'bs5 btn btn-secondary w105 ' + ((searchValues.searchKeyword) || searchValues.searchArrayData?.length > 0 ? "" : "disabled")}
                        onClick={() => onSearch()}
                        disabled={!((searchValues.searchKeyword) || searchValues.searchArrayData?.length > 0)}>
                        {t('search')}
                    </button>
                </div>
                <div className="bs5 mt-3 pt-2">
                    <a href={void (0)} data-toggle="modal" data-target="#delete-quote-Modal"
                        onClick={(e) => {
                            e.preventDefault();
                            System.popup('OrderAdvanceFilterPopup')
                        }}><i className="fa fa-filter text-blue-stone me-1"></i>Advanced Filters</a>
                </div>
            </div>
            <ObjCommonFilterSelection />
        </>
    )
}

export default OrderHistorySearchFilter